import { render, staticRenderFns } from "./BestSellerList.vue?vue&type=template&id=cedc4a4a&scoped=true&"
import script from "./BestSellerList.vue?vue&type=script&lang=js&"
export * from "./BestSellerList.vue?vue&type=script&lang=js&"
import style0 from "./BestSellerList.vue?vue&type=style&index=0&id=cedc4a4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cedc4a4a",
  null
  
)

export default component.exports